import { IUsuarioReestablecerPasswordModel } from "../interfaces/seguridad/IUsuarioReestablecerPasswordModel";

export class UsuarioReestablecerPasswordModel implements IUsuarioReestablecerPasswordModel {
    id: string;
    newPassword: string;
    token: string;

    constructor(){
        this.id = '';
        this.newPassword = '';
        this.token = '';
    }
}